module.exports = __webpack_public_path__ + "button2.png?5ba5eed81afbf067b28d729040ce1445";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/button2.png
// module id = 23
// module chunks = 0